import { lazy } from "react";

const KEY = "chunk_reload_at";
export const isChunkError = (e) => /Loading chunk|ChunkLoadError|Failed to fetch dynamically imported module|Importing a module script failed/i.test(String(e?.message || e?.name || e || ""));

/** After a deploy the old tab asks for chunk files that no longer exist → reload once to pick up the new build instead of showing an error. */
export function reloadForNewVersion() {
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last < 30000) return false;          // already reloaded recently — don't loop
  sessionStorage.setItem(KEY, String(Date.now()));
  window.location.reload();
  return true;
}

export const lazyRetry = (importer) => lazy(() => importer().catch((e) => {
  if (isChunkError(e) && reloadForNewVersion()) return new Promise(() => {}); // page is reloading; never resolve
  throw e;
}));
